import { debounce } from 'debounce';
import { mergeDeepRight } from 'ramda';
import * as ActionCreators from './actions/creators';
import * as Actions from './actions/types';
import { isAuthenticated } from '@/auth/auth-access';
import { getConfig } from '@/config';
import * as LocalStorage from '@/stores/local-storage';
import * as SessionStorage from '@/stores/session-storage';
import { DEFAULT_PERSIST_INTERVAL, STORAGE_KEY } from '@/stores/stores.constants';
export const debouncedPersistToLocalStorage = debounce((state, key) => LocalStorage.persist(state, key), DEFAULT_PERSIST_INTERVAL);
export const debouncedPersistToSessionStorage = debounce((state, key) => SessionStorage.persist(state, key), DEFAULT_PERSIST_INTERVAL);
export const persistedMiddleware = (key = STORAGE_KEY) => (store) => (next) => (action) => {
    var _a;
    const newState = next(action);
    if ((_a = action.meta) === null || _a === void 0 ? void 0 : _a.persistImmediately) {
        debouncedPersistToLocalStorage.clear();
        LocalStorage.persist(store.getState(), key);
    }
    else {
        debouncedPersistToLocalStorage(store.getState(), key);
    }
    if (isAuthenticated() && action.type !== Actions.LOGOUT) {
        debouncedPersistToSessionStorage(store.getState(), key);
    }
    return newState;
};
export const enhancedReducer = (reducer) => (state, action) => {
    if (action.type === Actions.PERSIST_INIT) {
        const newState = mergeDeepRight(state, action.payload || {});
        return newState;
    }
    return reducer(state, action);
};
export const persistedStoreEnhancer = (key = STORAGE_KEY) => (createStore) => (reducer, ...args) => {
    const store = createStore(enhancedReducer(reducer), ...args);
    const persistedStateFromLocalStorage = LocalStorage.ls.getItem(key);
    // Migration: remove any legacy `auth` key persisted before BS-1124
    if (persistedStateFromLocalStorage && 'auth' in persistedStateFromLocalStorage) {
        delete persistedStateFromLocalStorage.auth;
        LocalStorage.ls.setItem(key, persistedStateFromLocalStorage);
    }
    const persistedStateFromSessionStorage = SessionStorage.ss.getItem(key);
    store.dispatch(ActionCreators.persistInit(mergeDeepRight(persistedStateFromLocalStorage, persistedStateFromSessionStorage !== null && persistedStateFromSessionStorage !== void 0 ? persistedStateFromSessionStorage : {})));
    return store;
};
export const createMiddlewareArray = () => {
    const middlewareArray = [];
    if (!getConfig().skipAuthentication) {
        middlewareArray.push(persistedMiddleware());
    }
    return middlewareArray;
};
